// Names must match the entries returned by `GET /feature-toggle`.
export const FEATURES = {
    TABLE_RESERVATIONS: 'table-reservations',
};
